var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.007.2l-5.46 30.68h9.1v32.24H.567v-32.5L9.147.2h15.86zm42.12 0l-5.46 30.68h9.1v32.24h-28.08v-32.5L51.267.2h15.86z"}));
}

Quote.defaultProps = {"width":"71","height":"64","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
